import Vue from 'vue'
import store from './store'
import router from './router'
import PortalVue from 'portal-vue'
import VueResource from 'vue-resource'
import * as VueGoogleMaps from 'vue2-google-maps'
import { VueHammer } from 'vue2-hammer'
import VueScrollTo from 'vue-scrollto'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import Signup from "@afrihost/vue-signup";
import "@afrihost/vue-signup/dist/afrihost-signup.css";

import GoogleReviewsPlugin from '@afrihost/google-reviews';
import "@afrihost/google-reviews/dist/google-reviews.css";
// import "@afrihost/vue-signup/dist/img/afrihost-logo.png";
// import "@afrihost/vue-signup/dist/img/afrihost-logo@2x.png";
// import "@afrihost/vue-signup/dist/img/router.png";

Vue.use(PortalVue);
Vue.use(VueResource);
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyB_jNrg_FCQ8F-nLgBhRNb9149pqIkIggo',
        libraries: 'places',
    },

    // If you intend to programmatically custom event listener code
    // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    // you might need to turn this on.
    // autobindAllEvents: false,

    // If you want to manually install components, e.g.
    // import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    // Vue.component('GmapMarker', GmapMarker)
    // then disable the following:
    // installComponents: true,
});
Vue.use(VueHammer);
VueHammer.config.swipe = {
    direction: 6,
};

Vue.use(GoogleReviewsPlugin, {
	ctaLabel: 'Get Pure Fibre Now',
});

Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: -60,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});

Vue.use(Signup, {
	store: store,
	storeKey: process.env.MIX_SIGNUP_PLUGIN_STORE_KEY,
	solutionTypes: ['composite_fibre'],
	upsellSolutionTypes: ['connectivity_mobile'],
	googleMapsKey: 'AIzaSyB_jNrg_FCQ8F-nLgBhRNb9149pqIkIggo',
	pageRequestedFrom: process.env.MIX_SIGNUP_PLUGIN_PAGE_REQUESTED_FROM,
	testSignup: process.env.MIX_SIGNUP_PLUGIN_TEST === "true",
	decoInStock: {
		twoPack: process.env.MIX_SIGNUP_PLUGIN_DECO_2_IN_STOCK === "true",
		threePack: process.env.MIX_SIGNUP_PLUGIN_DECO_3_IN_STOCK === "true",
	},
	fibreFreeze: process.env.MIX_SIGNUP_PLUGIN_FIBRE_FREEZE === "true",
	fibreTypeScope: 'fibre_uncapped_pure', // fibre_prepaid
	signalUuid: process.env.MIX_SIGNAL_UUID
})

Sentry.init({
    dsn: 'https://c33b28441b5b48d4a0b95fdef7828477@sentry.sys.afrihost.com/14',
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
    environment: process.env.NODE_ENV === 'production' ? 'production' : 'development',
});

import GoogleReviews from './components/GoogleReviews'
import Packages from './views/BrowsePackages'
import HeaderSearchBar from './views/HeaderSearchBar'
import CoverageCheck from './views/CoverageCheck'
import Modal from './views/Modal'
import Modal5k from './components/Modal5k'
import ModalUpgradePromo from './components/ModalUpgradePromo'
import Devices from "./components/Devices";
import ProviderList from "../../spiderman/views/ProviderList.vue";

new Vue({
	name: 'packages-component',
    el: '.packages-component',
    store,
    render: h => h(Packages)
});

new Vue({
	el: 'installation-freeze',
	store,
	render: h => h(InstallationFreeze)
});

new Vue({
	name: 'search-bar',
    el: '.search-bar',
    store,
    router,
    render: h => h(CoverageCheck)
});

new Vue({
	name: 'signup-modal',
	el: 'signup-modal',
});

new Vue({
	el: '.vueplease',
});

new Vue({
	name: 'fibre-modal',
    el: 'fibre-modal',
    store,
    router,
    render: h => h(Modal)
});

new Vue({
	name: 'nav',
    el: 'nav',
});

new Vue({
	name: 'google-reviews',
	el: 'google-reviews',
	methods: {
		callback() {
			this.$scrollTo('header');
		}
	}
});

new Vue({
    el: '[v-scroll-to]',
});

new Vue({
	name: 'devices-component',
	el: '.devices-component',
	store,
	render: h => h(Devices)
});


new Vue({
	name: 'providers',
	el: '.providers',
	render: h => h(ProviderList)
})

new Vue({
    name: 'modal-5k',
    el: 'modal-5k',
    store,
    render: h => h(Modal5k)
});

new Vue({
	name: 'modal-upgrade',
	el: 'modal-upgrade',
	store,
	render: h => h(ModalUpgradePromo)
});


new Vue({
    name: 'header-promo-bar',
    el: '.header-promo-bar',
    store,
    methods: {
        openPromoModal() {
            this.$store.commit('general/updatePromoModalVisibility', true);
        },
		toTerms() {
			this.$scrollTo('.provider-terms h5');
		}
    }
});

// new Vue({
//     el: '.header-upgrade-promo',
// //     store,
//     methods: {
// 		showUpgradeModal() {
//             this.$store.commit('general/updateUpgradeModalVisibility', true);
//         }
//     }
// });


new Vue({
    name: 'selling-points',
    el: '.selling-points',
    data() {
        return {
            assetUrl: window._assetBaseUrl,
            activeTab: 0,
            tabCount: 4
        }
    },
    methods: {
        setActiveTab(tab) {
            this.activeTab = tab;
        },

        nextSlide() {
            if (this.activeTab < this.tabCount - 1) {
                this.activeTab++;
            } else {
                this.activeTab = 0;
            }
        },

        prevSlide() {
            if (this.activeTab > 0) {
                this.activeTab--;
            } else {
                this.activeTab = this.tabCount - 1;
            }
        },

        jumpToSlide(index) {
            this.activeTab = parseInt(index);
        },

        onSwipe(event) {
            switch (event.type) {
                case 'swipeleft':
                    this.nextSlide();
                    break;
                case 'swiperight':
                    this.prevSlide();
                    break;
            }
        }
    },
});

new Vue({
    name: 'about-afrihost',
    el: '.about-afrihost',
    data() {
        return {
            slideCount: 4,
            slide: 0
        }
    },
    methods: {

        nextSlide() {
            if (this.slide < this.slideCount - 1) {
                this.slide++;
            } else {
                this.slide = 0;
            }
        },

        prevSlide() {
            if (this.slide > 0) {
                this.slide--;
            } else {
                this.slide = this.slideCount - 1;
            }
        },

        jumpToSlide(index) {
            this.slide = parseInt(index);
        },

        onSwipe(event) {
            switch (event.type) {
                case 'swipeleft':
                    this.nextSlide();
                    break;
                case 'swiperight':
                    this.prevSlide();
                    break;
            }
        }

    },
});

new Vue({
    name: 'provider-terms',
    el: '.provider-terms',
	store,
    data() {
        return {
            isCollapsed: false
        }
    },
    methods: {
		toggleExpand() {
			this.isCollapsed = !this.isCollapsed;
		},
		openPromoModal() {
			this.$store.commit('general/updatePromoModalVisibility', true);
		},
    }
});

// FAQs binding
Vue.directive('toggle-faq', {
    bind: (el) => {
        el.addEventListener('click', () => {
            el.classList.toggle('is-open');
        });
    }
});

new Vue({
    name: 'help',
    el: '.help',
	methods: {
		usefulToolClick(name, e) {
			if (dataLayer && e) {
				dataLayer.push({
					event: 'Useful_Tools.Click',
					name: name
				});
			}
		},
		supportClick(name, e) {
			if (dataLayer && e) {
				dataLayer.push({
					event: 'Support_Platforms.Click',
					name: name
				});
			}
		},
	}
});

// import SpiderModal from '../../spiderman/Modal.vue'
// new Vue({
// 	el: 'spider-modal',
// 	render: h => h(SpiderModal)
// });

import axios from "axios";
import InstallationFreeze from "./modals/InstallationFreeze.vue";
const signalInstance = axios.create({
	baseURL: 'https://signal.afrihost.com/api/',
	withCredentials: true,
	headers: {
		'Accept': 'application/json',
		'Content-Type': 'application/json',
	}
})

if(window && process.env.MIX_SIGNAL_UUID) {


	const searchParams = new URLSearchParams(window.location.search);

	// signal page view
	let l = window.location
	let path = l.pathname
	let source = searchParams.get('utm_source')
	let medium = searchParams.get('utm_medium')
	let campaign = searchParams.get('utm_campaign')

	let event = {
		type: 'page-view',
		value: null,
		path: path,
		meta: null,
		campaign: campaign,
		medium: medium,
		source: source
	}

	signalInstance.post(`/public/project/${process.env.MIX_SIGNAL_UUID}/event`, event)

}

